//
// Template tags
//
export default [
  'general', 'specific',
  'schools', 'pre-schools', 'homes', 'parenting',
  'children', 'teenagers', 'adults',
];
